/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink } from '@nebular/auth/auth.options';
import { getDeepFromObject } from '@nebular/auth/helpers';

import { NbAuthService } from '../auth.service';
import { NbAuthResult } from '@nebular/auth/services/auth-result';


@Component({
  selector: 'nb-register',
  styleUrls: ['./register.component.scss'],
  template: `
    <nb-auth-block>
      <h2 class="title">Sign Up</h2>
      <form (ngSubmit)="register()" #form="ngForm">
        
        <!-- error message -->

        <div *ngIf="showMessages.error && errors && !submitted"
            class="alert alert-danger" role="alert">
          <div><strong>Oh snap!</strong></div>
          <div *ngFor="let error of errors">{{ error }}</div>
        </div>
        
        <div class="form-group">
          <label for="first-name" class="sr-only">First name</label>
          <input name="firstname" [(ngModel)]="user.firstname" id="first-name" #firstname="ngModel"
                 class="form-control" placeholder="First name"
                 [class.form-control-danger]="firstname.invalid && firstname.touched"
                 [required]="true"
                 autofocus>
          <small class="form-text error" *ngIf="firstname.invalid && firstname.touched && firstname.errors?.required">
            First name is required!
          </small>
          
        </div>

        <div class="form-group">
          <label for="second-name" class="sr-only">Second name</label>
          <input name="secondname" [(ngModel)]="user.secondname" id="second-name" #secondname="ngModel"
                 class="form-control" placeholder="Second name"
                 [class.form-control-danger]="secondname.invalid && secondname.touched"
                 [required]="true"
                 autofocus>
          <small class="form-text error" *ngIf="secondname.invalid && secondname.touched && secondname.errors?.required">
            Second name is required!
          </small>
          
        </div>

        <div class="form-group">
          <label for="input-email" class="sr-only">Email address</label>
          <input name="email" [(ngModel)]="user.email" id="input-email" #email="ngModel"
                 class="form-control" placeholder="Email address" pattern=".+@.+\..+"
                 [class.form-control-danger]="email.invalid && email.touched"
                 [required]="true">
          <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">
            Email is required!
          </small>
          <small class="form-text error"
                 *ngIf="email.invalid && email.touched && email.errors?.pattern">
            Email should be the real one!
          </small>
        </div>

        <div class="form-group">
          <label for="input-password" class="sr-only">Password</label>
          <input name="password" [(ngModel)]="user.password" type="password" id="input-password"
                 class="form-control" placeholder="Password" #password="ngModel"
                 [class.form-control-danger]="password.invalid && password.touched"
                 [required]="true">
          <small class="form-text error" *ngIf="password.invalid && password.touched && password.errors?.required">
            Password is required!
          </small>
          
        </div>

        <div class="form-group">
          <label for="input-re-password" class="sr-only">Repeat password</label>
          <input
            name="rePass" [(ngModel)]="user.confirmPassword" type="password" id="input-re-password"
            class="form-control" placeholder="Confirm Password" #rePass="ngModel"
            [class.form-control-danger]="(rePass.invalid || password.value != rePass.value) && rePass.touched"
            [required]="true">
          <small class="form-text error"
                 *ngIf="rePass.invalid && rePass.touched && rePass.errors?.required">
            Password confirmation is required!
          </small>
          <small
            class="form-text error"
            *ngIf="rePass.touched && password.value != rePass.value && !rePass.errors?.required">
            Password does not match the confirm password.
          </small>
        </div>

        <button [disabled]="submitted || !form.valid" class="btn btn-block btn-hero-success"
                [class.btn-pulse]="submitted">
          Register
        </button>
      </form>

      <div class="links">
        <small class="form-text">
          Already have an account? <a routerLink="../login"><strong>Sign in</strong></a>
        </small>
      </div>
    </nb-auth-block>
  `,
})
export class NbRegisterComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected router: Router) { }

  register(): void {
    /*this.errors = this.messages = [];
    this.submitted = true;

    this.service.register(this.user).subscribe(
      result => {
        this.submitted = false;
        result = result.json();
        if (result.success) {
          localStorage.setItem("token",result.token);
          localStorage.setItem("role","root");
          this.router.navigateByUrl("/dashboard");
        } else {
          this.errors = [ result.msg ];
          this.showMessages = { error : true };
        }
        
      },
      err => { console.log(err) }
    );*/
  }
}
